export { default } from '@shikijs/langs/v'
